import { ofType } from 'redux-observable';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import {
  fetchTeams,
  fetchTeamsSuccess,
  fetchTeamsFailure,
  teamSetting,
  teamSettingSuccess,
  teamSettingFailure,
  teamDelete,
  teamDeleteSuccess,
  teamDeleteFailure,
  teamCreate,
  teamCreateSuccess,
  teamCreateFailure,
  fetchTeamMembers,
  fetchTeamMembersSuccess,
  fetchTeamMembersFailure,
  inviteTeamMember,
  inviteTeamMemberSuccess,
  inviteTeamMemberFailure,
  updateTeamMemberRole,
  updateTeamMemberRoleSuccess,
  updateTeamMemberRoleFailure,
  deleteTeamMember,
  deleteTeamMemberSuccess,
  deleteTeamMemberFailure,
  cancelTeamInvitation,
  cancelTeamInvitationSuccess,
  cancelTeamInvitationFailure,
} from '../slices/teamsSlice';

const toError = (err, fallback = '網路或伺服器錯誤') => ({
  msg: err?.response?.msg || err?.message || fallback,
  raw: err?.response || null,
});

export const fetchTeamsEpic = (action$) =>
  action$.pipe(
    ofType(fetchTeams.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_teams/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => fetchTeamsSuccess({ data: res.response.data })),
        catchError((err) => of(fetchTeamsFailure(toError(err))))
      )
    )
  );

export const teamSettingEpic = (action$) =>
  action$.pipe(
    ofType(teamSetting.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_update/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => teamSettingSuccess({ data: res.response.data })),
        catchError((err) => of(teamSettingFailure(toError(err))))
      )
    )
  );

export const teamDeleteEpic = (action$) =>
  action$.pipe(
    ofType(teamDelete.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_delete/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => teamDeleteSuccess({ data: res.response.data })),
        catchError((err) => of(teamDeleteFailure(toError(err))))
      )
    )
  );

export const teamCreateEpic = (action$) =>
  action$.pipe(
    ofType(teamCreate.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_create/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => teamCreateSuccess({ data: res.response.data })),
        catchError((err) => of(teamCreateFailure(toError(err))))
      )
    )
  );

export const fetchTeamMembersEpic = (action$) =>
  action$.pipe(
    ofType(fetchTeamMembers.type),
    mergeMap((action) =>
      ajax({
        url: '/api/get_team_members/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => fetchTeamMembersSuccess({ data: res.response.data })),
        catchError((err) => of(fetchTeamMembersFailure(toError(err))))
      )
    )
  );

export const inviteTeamMemberEpic = (action$) =>
  action$.pipe(
    ofType(inviteTeamMember.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_member_invite/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => inviteTeamMemberSuccess({ data: res.response.data, msg: res.response.msg })),
        catchError((err) => of(inviteTeamMemberFailure(toError(err))))
      )
    )
  );

export const updateTeamMemberRoleEpic = (action$) =>
  action$.pipe(
    ofType(updateTeamMemberRole.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_member_role_update/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => updateTeamMemberRoleSuccess({ data: res.response.data })),
        catchError((err) => of(updateTeamMemberRoleFailure(toError(err))))
      )
    )
  );

export const deleteTeamMemberEpic = (action$) =>
  action$.pipe(
    ofType(deleteTeamMember.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_member_delete/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => deleteTeamMemberSuccess({ data: res.response.data })),
        catchError((err) => of(deleteTeamMemberFailure(toError(err))))
      )
    )
  );

export const cancelTeamInvitationEpic = (action$) =>
  action$.pipe(
    ofType(cancelTeamInvitation.type),
    mergeMap((action) =>
      ajax({
        url: '/api/team_invitation_cancel/',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: action.payload,
        timeout: 30000,
      }).pipe(
        map((res) => cancelTeamInvitationSuccess({ data: res.response.data })),
        catchError((err) => of(cancelTeamInvitationFailure(toError(err))))
      )
    )
  );
